module.exports = __webpack_public_path__ + "img/bulb.45b1c233.gif";